module.exports = __webpack_public_path__ + "static/media/main.c8123052.png";